import React, { useState } from "react";

const BlobUploadForm = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [fileUrl, setFileUrl] = useState("");

  const baseUri = "https://softoopwsh.blob.core.windows.net/baader";
  const sasToken =
    "si=*&sv=2024-11-04&sr=c&sig=m%2BGKZyClHHVOlQ1QZAdZzFAyCRg%2Bwnyp%2BHrYHvNrJHY%3D";

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setFileUrl(""); // Reset on new selection
    setMessage("");
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage("Please select a file.");
      return;
    }

    const fileName = encodeURIComponent(file.name);
    const blobUrl = `${baseUri}/${fileName}?${sasToken}`;

    try {
      const res = await fetch(blobUrl, {
        method: "PUT",
        headers: {
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": file.type || "application/octet-stream",
        },
        body: file,
      });

      if (res.ok) {
        const finalUrl = `${baseUri}/${fileName}`;
        setFileUrl(finalUrl);
        console.log(finalUrl)
        setMessage("✅ File uploaded successfully!");
      } else {
        setMessage(`❌ Upload failed. Status: ${res.status}`);
      }
    } catch (error) {
      setMessage(`⚠️ Upload error: ${error.message}`);
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-4">Upload File to Azure Blob</h2>
      <form onSubmit={handleUpload} className="space-y-4">
        <input
          type="file"
          onChange={handleFileChange}
          className="border p-2 rounded w-full"
        />
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Upload
        </button>
      </form>

      {message && <p className="mt-4 text-sm text-gray-800">{message}</p>}

      {fileUrl && (
        <div className="mt-2">
          <label className="block text-sm font-medium">File URL:</label>
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline break-all"
          >
            {fileUrl}
          </a>
        </div>
      )}
    </div>
  );
};

export default BlobUploadForm;
